import { render, staticRenderFns } from "./create_update.vue?vue&type=template&id=532fc62e&scoped=true&"
import script from "./create_update.vue?vue&type=script&lang=js&"
export * from "./create_update.vue?vue&type=script&lang=js&"
import style0 from "./create_update.vue?vue&type=style&index=0&id=532fc62e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fc62e",
  null
  
)

export default component.exports